import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import { IMAGES } from '../data/menuData';
import './Links.css';

export default function Links() {
  const { lang, setLang, t } = useLang();
  const navigate = useNavigate();

  const links = [
    { key: 'website', icon: '🌐', label: t('links.website'), sub: t('links.website.sub'), onClick: () => navigate('/') },
    { key: 'menu', icon: '📜', label: t('links.menu'), sub: t('links.menu.sub'), onClick: () => navigate('/flipbook') },
    { key: 'reservations', icon: '🍽️', label: t('links.reservations'), sub: t('links.reservations.sub'), onClick: () => navigate('/reservations') },
  ];

  return (
    <div className="links-page">
      <div className="links-photo" style={{ backgroundImage: `url(${IMAGES.hero})` }} />
      <div className="links-overlay" />

      <div className="lang-switcher links-lang">
        <button className={"lang-btn" + (lang === 'fr' ? ' active' : '')} onClick={() => setLang('fr')}>FR</button>
        <button className={"lang-btn" + (lang === 'en' ? ' active' : '')} onClick={() => setLang('en')}>EN</button>
      </div>

      <div className="links-content">
        <img src="/gemiya-logo.png" alt="Gemiya" className="links-logo" />
        <div className="links-eyebrow">{t('links.eyebrow')}</div>
        <h1 className="links-title">Gemiya</h1>
        <p className="links-desc">{t('links.desc')}</p>

        <div className="links-buttons">
          {links.map(l => (
            <button key={l.key} className="links-btn" onClick={l.onClick}>
              <span className="links-btn-icon">{l.icon}</span>
              <span className="links-btn-text">
                <span className="links-btn-label">{l.label}</span>
                <span className="links-btn-sub">{l.sub}</span>
              </span>
              <span className="links-btn-arrow">→</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
